import { useEffect, useState } from 'react';
import { sprekersApi } from '../api';
import { isGoogleSlidesConfigured } from './googleConfig';

/**
 * Mag de ingelogde gebruiker de Google Slides-import gebruiken? De beslissing
 * komt van de server (pilot-allowlist op de geauthenticeerde user-id, standaard
 * deny); de frontend rekent niets zelf uit. Zonder build-configuratie wordt de
 * server niet eens gevraagd, en bij een fout of vertraging is het antwoord nee.
 */
export default function useGoogleSlidesAccess(): boolean {
  const configured = isGoogleSlidesConfigured();
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    if (!configured) {
      setAllowed(false);
      return undefined;
    }
    let active = true;
    sprekersApi
      .getGoogleSlidesStatus()
      .then((status) => {
        if (active) setAllowed(status?.enabled === true);
      })
      .catch(() => {
        if (active) setAllowed(false);
      });
    return () => {
      active = false;
    };
  }, [configured]);

  return configured && allowed;
}
